/** Intervalo de atualização dos modos TV. O rodapé mostra "Atualizado há X min". */
export const INTERVALO_TV_MS = 30 * 60_000;

export interface OpcoesPainel {
  /** Modo TV: atualiza sozinho e não mostra toast de erro (mantém o último dado). */
  autoAtualizar?: boolean;
}

export function opcoesPainel({ autoAtualizar }: OpcoesPainel = {}) {
  return autoAtualizar ? { refetchInterval: INTERVALO_TV_MS, meta: { silent: true } } : {};
}
